import React, { useEffect, useState } from 'react'
import Axios from 'axios'
import Table from '../table'
import DataLayout from '../data-layout'

const SpendingByVendor = ({
  match: {
    params: { year }
  }
}) => {
  const [data, setData] = useState([])

  useEffect(() => {
    const loadData = async () => {
      const result = await Axios.get(`/GetVendorSpending/${year}`)
      const _data = result.data.map(d => ({
        name: d.VendorName.trim(),
        nameClick: `/vendor/${year}/${
          d.VendorNo
        }?vendorName=${d.VendorName.trim()}`,
        data: d.Amount
      }))
      setData(_data.sort((a, b) => b.name - a.name))
    }

    loadData()
  }, [year])

  return (
    <DataLayout year={year}>
      <Table
        data={{
          headers: [
            {
              title: 'Name',
              dataKey: 'name',
              clickThrough: 'nameClick'
            },
            {
              title: 'Amount',
              dataKey: 'data'
            }
          ],
          data
        }}
      />
    </DataLayout>
  )
}

export default SpendingByVendor
